<template>
    <div id="chatHeader" :class="{ roundedHeader: roundedHeader }">
        <div class="header-container">
            <div class="left">
                <!--                <div class="icon-container">-->
                <!--                    <EllipsIconButton-->
                <!--                        padding="16px"-->
                <!--                        radius="10px"-->
                <!--                        :iconName="leftIconIndexes.includes(pageIndex) ? 'ArrowL' : 'ArrowB'"-->
                <!--                        bgColor="rgba(255, 255, 255, 0.31)"-->
                <!--                        @btnClicked="() => arrowButtonClickHandler()"-->
                <!--                    />-->
                <!--                </div>-->
                <div v-if="connected" class="user-container">
                    <div v-if="this.pageIndex === 1" style="display: flex; align-items: center">
                        <div class="image-container" v-if="chatAgents.length">
                            <a-avatar :username="agentName()" :src="getAgentImage()" class="avatar agent-avatar">
                                {{ agentName().substr(0, 1).toUpperCase() }}
                            </a-avatar>
                            <div class="status-dot"></div>
                        </div>
                        <div v-if="chatAgents.length" class="title-container text-container">
                            {{ representativeName || chatTitle }}
                        </div>
                        <!-- isimsiz bot/katilimcida baslik bos kalmasin: panelden yazilan basliga duser -->
                        <div v-else class="title-container text-container">
                            {{ title || chatTitle }}
                        </div>
                    </div>
                    <div v-else style="display: flex; align-items: center">
                        <div class="title-container text-container">
                            {{ shownTitle }}
                        </div>
                    </div>
                </div>
                <div v-else class="waiting-header">
                    <span v-if="previewMode && !previewPrecall" style="color: var(--header-text-color)">John Doe</span>
                    <span v-else style="color: var(--header-text-color)" class="default-title-length">{{
                        shownTitle
                    }}</span>
                </div>
            </div>
            <div class="options-container">
                <div class="options-button-container" id="optionOpenButton">
                    <EllipsIconButton
                        class="header-icon-button"
                        width="20px"
                        height="20px"
                        padding="6px"
                        radius="var(--sps-radius-sm)"
                        hovered-bg-color="rgba(15, 23, 42, 0.06)"
                        :iconName="leftIconIndexes.includes(pageIndex) ? 'BackIcon' : ($store.getters['shell/enabled'] ? 'BackIcon' : 'MinimizeIcon')"
                        @btnClicked="() => arrowButtonClickHandler()"
                    />
                    <EllipsIconButton
                        class="header-icon-button"
                        width="20px"
                        height="20px"
                        padding="6px"
                        radius="var(--sps-radius-sm)"
                        hovered-bg-color="rgba(15, 23, 42, 0.06)"
                        @btnClicked="toggleMenu"
                        iconName="MoreIcon"
                    />
                </div>
                <HeaderOptions
                    v-if="optionsIsVisible"
                    :connected="connected"
                    :isIframeMode="isIframeMode"
                    :visitorGDPRDeleteEnabled="visitorGDPRDeleteEnabled"
                    :ticketMode="ticketMode"
                    :volume="volume"
                    @closePopup="optionsIsVisible = false"
                    @showTicketForm="() => showTicketForm()"
                    @deleteKVKK="() => deleteKVKK()"
                    @showChatHistory="() => showChatHistory()"
                    @maximize="() => maximize()"
                    @localVolume="(volume) => (localVolume = volume)"
                    @closeChat="() => $emit('closeChat')"
                />
                <a-modal
                    :visible="langSelection"
                    centered
                    hide-footer
                    hide-header
                    :footer="null"
                    @cancel="langSelection = false"
                >
                    <div class="d-flex flex-column">
                        <h6 style="font-size: 14px; color: var(--color4) !important">
                            {{ $t("message.languageSelection") }}
                        </h6>
                        <a-select
                            v-model="preferredLang"
                            class="my-2"
                            show-search
                            option-filter-prop="children"
                            :filter-option="filterOption"
                            :autofocus="true"
                        >
                            <a-select-option v-for="lang in languages" :key="lang.code" :value="lang.code"
                                >{{ lang.originalName }}
                            </a-select-option>
                        </a-select>
                        <a-button
                            class="btnUpdateLang btn-lang-background"
                            type="primary"
                            variant="success"
                            @click="updateLang"
                        >
                            <span>
                                {{ $t("message.save") }}
                            </span>
                        </a-button>
                    </div>
                </a-modal>
            </div>
        </div>
    </div>
</template>

<script>
import CloseIcon from "./assets/close-icon-big.png";
import { mapActions, mapMutations, mapState } from "vuex";
import {
    parentWindowMessageStream,
    sendCommandToParentWindow,
    sendMaximizeAction,
    sendMinimizeAction,
} from "../../../utils/parentWindowConnection";
import * as _ from "lodash";
import { log2 } from "../../../utils/log2";
import { publishMessage, systemMessageStream, SystemMessageTypes } from "../../../utils/systemPubSub";
import languages from "../../../language/languages.json";
import { sendSocketMessage } from "../../../utils/socketStream";
import { filter, map } from "rxjs/operators";
import { getPersistenceData } from "../../../utils/persistenceStorage";
import { resolveChatText } from "../../../utils/chatTexts";
import { getParticipantAvatar } from "../../../utils/conversationHandler";
import Head from "../Head";
import CardHead from "./CardHead";
import HeaderOptions from "./HeaderOptions.vue";
import EllipsIconButton from "../../../common/IconButton.vue";

const log = log2("HeaderV2");
export default {
    name: "HeaderV2",
    components: {
        Head,
        CardHead,
        HeaderOptions,
        EllipsIconButton,
    },
    props: {
        icons: {
            type: Object,
            default: function () {
                return {
                    close: {
                        img: CloseIcon,
                        name: "default",
                    },
                };
            },
        },
        participants: {
            type: Array,
            required: true,
        },
        imageUrl: {
            type: String,
            required: true,
        },
        title: {
            type: String,
        },
        colors: {
            type: Object,
            required: true,
        },
        isRootCatalog: {
            type: Boolean,
            required: false,
            default: true,
        },
        ticketMode: {
            type: Boolean,
            required: true,
        },
        headerTitle: {
            type: String,
            required: false,
        },
    },
    computed: {
        // panelden yazilan pencere basligi; bos ise hazir "Bizimle sohbet edin"
        chatTitle() { return resolveChatText(this.settings, "title", this.$i18n.locale, this.$t("message.chatWithUs")); },
        // ana sohbet ekraninda baslik dogrudan ayardan; defaultTitle sayfa gecislerinde (degerlendirme 5/6) bos kalabiliyor
        shownTitle() { return this.pageIndex === 1 ? this.chatTitle : this.defaultTitle; },
        ...mapState({
            connected: (state) => state.chat.connected,
            site: (state) => state.site.site,
            queueNumber: (state) => state.chat.queueNumber,
            chatAgents: (state) => state.chat.chatAgents,
            settings: (state) => state.setting.settings,
            visitorGDPRDeleteEnabled: (state) => _.get(state, "setting.settings.visitorGDPRDeleteEnabled", true),
            volume: (state) => state.app.volume,
            previewMode: (state) => state.app.previewMode,
            // sohbet oncesi form onizlemesinde sohbet baslamamis: demo temsilci adi yerine pencere basligi
            previewPrecall: (state) => _.get(state.setting.previewDraft, "__previewView") === "precall",
            visitorId: (state) => state.chat.visitorId,
            autoTranslate: (state) => state.chat.autoTranslate,
            language: (state) => state.language.language,
            pageIndex: (state) => state.app.pageIndex,
            lastPageIndex: (state) => state.app.lastPageIndex,
        }),
        filteredMessages() {
            return this.messages.filter(
                (m) =>
                    "customer-typing" !== m.type &&
                    "private" !== m.type &&
                    ("undefined" !== typeof m.message || "undefined" !== typeof m.description) &&
                    m.systemMessageType !== "customer-offline" &&
                    m.systemMessageType !== "customer-online"
            );
        },
        defaultPageIndexes() {
            if (this.pageIndex === 4) {
                return this.$t("message.selectChatLang");
            } else if (this.pageIndex === 3) {
                return this.$t("message.chatHistory");
            } else if (this.pageIndex === 5) {
                return this.participants.length
                    ? this.participants[0].name.substr(0, 1).toUpperCase() +
                          " " +
                          this.$t("visitorLanguage.rateTheMeting")
                    : this.$t("visitorLanguage.rateTheEmptyMeting");
            } else if (this.pageIndex === 6) {
                return "";
            } else if (this.pageIndex === 2) {
                return this.$t("message.createTicket");
            } else {
                return this.chatTitle;
            }
        },
    },
    updated() {
        log("updated", {
            optionsIsVisible: this.optionsIsVisible,
        });
    },
    mounted() {
        this.syncRepresentativeName();

        let c1 = systemMessageStream
            .pipe(
                filter((x) => x.type === "SET_VISITOR_LANG"),
                map((x) => x.payload.lang)
            )
            .subscribe((x) => {
                this.preferredLang = x;
            });
        let c2 = systemMessageStream
            .pipe(
                filter((x) => x.type === "open-lang-modal"),
                map((x) => x.payload)
            )
            .subscribe((x) => {
                this.langSelection = x;
            });
        const openOptionsSub = parentWindowMessageStream
            .pipe(filter((x) => ["iframe-open"].includes(x.command)))
            .subscribe(({ command, payload }) => {
                payload = payload || {};
                if (payload["initWithTickets"]) {
                    // Eskiden closeChat() dogrudan onClose() idi; sonradan onay
                    // uyarisina baglaninca FAB'daki talep aksiyonu "sohbeti kapat"
                    // sorusuna donusmustu. Formu acan showTicketForm yeterli.
                    this.showTicketForm();
                }
                if (payload["initWithLive"]) {
                    this.$emit("change-to-ticket", false);
                }
            });
        this.cancels.push(() => openOptionsSub.unsubscribe());
        this.cancels.push(() => c1.unsubscribe());
        this.cancels.push(() => c2.unsubscribe());
        this.$i18n.locale = this.languages.find((x) => x.code === this.preferredLang).code;
        if (window.self !== window.top) {
            this.roundedHeader = "roundedHeader";
        }
        log("mounted completed");
    },
    methods: {
        ...mapActions({
            resetConversation: "chat/resetConversation",
            disconnect: "chat/disconnect",
            updateVolume: "app/updateVolume",
            toggleAfterActions: "app/toggleAfterActions",
        }),

        ...mapMutations({
            setAutoTranslate: "chat/SET_AUTO_TRANSLATE",
            changePageIndex: "app/CHANGE_PAGE",
            goPrevPage: "app/GO_PREV_PAGE",
        }),
        getOrganizationLogo() {
            log("getOrganizationLogo");
            if (this.settings.organizationLogo && this.participants.length > 0) {
                const asset = this.settings.organizationLogo;
                this.organizationLogo =
                    this.participants[0].gravatar || asset.v2Format && asset.cdnUrl
                    ? asset.cdnUrl
                    :`https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
            } else {
                this.organizationLogo = "";
            }
        },
        toggleMenu() {
            this.$nextTick(() => {
                log("toggleMenu", !this.optionsIsVisible);
                this.optionsIsVisible = true;
            });
            this.$forceUpdate();
        },
        arrowButtonClickHandler() {
            if (this.leftIconIndexes.includes(this.pageIndex)) {
                return this.goPrevPage();
            }
            // Kabuk acikken sohbet ekranindaki ok Mesajlar listesine doner
            if (this.$store.getters["shell/enabled"]) return this.$store.dispatch("shell/closeChat");
            sendMinimizeAction();
        },
        updateLang() {
            this.$i18n.locale = this.preferredLang;
            this.langSelection = false;
            sendSocketMessage("visitor lang-change", {
                visitorId: this.visitorId,
                siteId: this.site._id,
                preferredLang: this.preferredLang,
                conversationId: getPersistenceData("conversationId"),
            });
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        deleteKVKK() {
            log("deleteKVKK");
            this.$emit("deleteKVKK");
        },
        showTicketForm() {
            log("showTicketForm");
            this.toggleAfterActions(false);
            this.resetConversation();
            // Talep formu yalnizca "bagli degilken" ciziliyor (ChatWindow'daki
            // v-if="!connected"). resetConversation yalnizca conversationId'yi
            // temizliyor, connected true kaliyordu: form hic gorunmuyordu.
            this.disconnect();
            publishMessage(SystemMessageTypes.RESTART_NEEDED, {});
            this.changePageIndex(2);
        },
        showChatHistory() {
            log("showChatHistory");
            this.changePageIndex(3);
        },
        openNewTab() {
            sendCommandToParentWindow("open-new-tab", {});
        },
        isIframeMode() {
            log("isIframeMode", window.parent !== window);
            // log("isIframeMode", window.parent !== window, window.parent != window);
            return window.parent !== window;
        },
        maximize() {
            sendMaximizeAction();
        },
        goBackToParent() {
            this.$emit("back-to-parent");
        },
        closeChat() {
            if (!this.previewMode) this.$emit("closeChat");
        },
        openFullscreen() {
            window.open("?catalog=fullscreen", "_blank");
        },
        agentName() {
            log("agentName", this.participants);
            return this.participants.length ? this.participants[0].name : this.$t("message.representative");
        },
        // avatar adla ayni katilimcidan okunur
        getAgentImage() {
            return getParticipantAvatar(this.participants[0], this.settings);
        },
        syncRepresentativeName() {
            const first = this.participants && this.participants.length ? this.participants[0] : null;
            const name = first && first.name ? String(first.name) : "";
            this.representativeName = name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
        },
        // data() icinden de cagrilir: computed (chatTitle) o anda henuz yok, ayar dogrudan store'dan okunur
        getPageIndex() {
            return resolveChatText(this.$store.state.setting.settings, "title", this.$i18n.locale, this.$t("message.chatWithUs"));
        },
    },
    beforeDestroy() {
        log("beforeDestroy");
        for (const cancel of this.cancels) cancel();
    },

    data() {
        let langCode = navigator.language.split("-")[0].toLowerCase();
        let maybeLang = languages.find((x) => x.code === langCode);
        return {
            languages,
            langSelection: false,
            isSwitched: false,
            preferredLang: !!maybeLang ? maybeLang.code : "tr",
            optionsIsVisible: false,
            baseUrl: () => {
                if (document.currentScript) {
                    let _documentUrl = document.currentScript.src.split("/");
                    return _documentUrl[0] + "//" + _documentUrl[2] + "/";
                } else {
                    return "/";
                }
            },
            localVolume: 100,
            leftIconIndexes: [4, 3],
            cancels: [],
            bgColor: "var(--primary_)",
            defaultTitle: this.getPageIndex(),
            organizationLogo: null,
            roundedHeader: "",
            representativeName: null,
        };
    },

    watch: {
        // ayarlar sonradan gelince ya da panelden degisince sohbet sayfasindaki baslik da guncellenir
        chatTitle(v, old) {
            if (!this.defaultTitle || this.defaultTitle === old) this.defaultTitle = v;
        },
        "$i18n.locale": {
            handler: function (newLocale, oldLocale) {
                this.defaultTitle = this.getPageIndex();
            },
            deep: true,
        },
        chatAgents() {
            this.syncRepresentativeName();
        },
        pageIndex() {
            if (this.pageIndex === 4) {
                this.defaultTitle = this.$t("message.selectChatLang");
            } else if (this.pageIndex === 3) {
                this.defaultTitle = this.$t("message.chatHistory");
            } else if (this.pageIndex === 5) {
                return this.participants.length
                    ? this.participants[0].name.substr(0, 1).toUpperCase() +
                          " " +
                          this.$t("visitorLanguage.rateTheMeting")
                    : this.$t("visitorLanguage.rateTheEmptyMeting");
            } else if (this.pageIndex === 6) {
                this.defaultTitle = "";
            } else if (this.pageIndex === 2) {
                this.defaultTitle = this.$t("message.createTicket");
            } else {
                this.defaultTitle = this.chatTitle;
            }
        },
        localVolume(newVal) {
            if (newVal !== this.volume) setTimeout(() => this.updateVolume(newVal), 100);
        },
        participants(newVal, oldVal) {
            this.syncRepresentativeName();
            if (this.participants.length && this.connected && this.organizationLogo === null) {
                this.getOrganizationLogo();
            }
            if (newVal.length === 1 && this.preferredLang !== newVal[0].lang && !this.autoTranslate) {
                this.setAutoTranslate(true);
                this.isSwitched = true;
            }
        },
    },
};
</script>

<style lang="scss">
body.v2 {
    @media (max-width: 450px) {
        .sc-header {
            border-radius: 0px;
        }
    }

    .title-chat {
        font-size: 1rem;
        line-height: 47px;
    }

    // Zemin %31 beyazdi: acik baslikta avatar tamamen gorunmez oluyordu.
    .agent-avatar {
        color: var(--button-color);
        font-weight: 600;
        width: 35px;
        height: 35px;
        overflow: hidden;
        border-radius: var(--sps-avatar-radius, 50%);
        background-color: var(--agent-bubble-color);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border: none !important;
    }

    // Nokta "fixed" ve sabit koordinattaydi: baslik olcusu degisince avatardan
    // kopuyordu. Artik avatarin sag alt kosesine bagli.
    .status-dot {
        width: 10px;
        height: 10px;
        background-color: #25e472;
        border: 2px solid var(--background-color-first, #fff);
        border-radius: 50%;
        position: absolute;
        right: -1px;
        bottom: -1px;
        box-shadow: 0 1px 3px rgba(37, 228, 114, 0.5);
    }

    .btn-lang-background {
        background-color: var(--button-color);
        border: 1px solid var(--button-color);
    }
}
.default-title-length {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/Header.vue